import { useSyncExternalStore } from 'react';
import { calendarEn, calendarNl } from './strings-calendar';
import { setupEn, setupNl } from './strings-setup';
import { adminEn, adminNl } from './strings-admin';
import { accountEn, accountNl } from './strings-account';
import { tourEn, tourNl } from './strings-tour';

const baseNl = {
  'nav.today': 'Vandaag',
  'nav.agenda': 'Agenda',
  'nav.clients': 'Klanten',
  'nav.salon': 'Salon',
  'nav.new': 'Nieuw',
  'auth.login.title': 'Inloggen',
  'auth.login.submit': 'Inloggen',
  'auth.login.noAccount': 'Nog geen account?',
  'auth.login.tryFree': 'Probeer 14 dagen gratis',
  'auth.signup.title': 'Probeer 14 dagen gratis',
  'auth.signup.subtitle': 'Geen betaalgegevens nodig. Je boekingspagina staat binnen 5 minuten live.',
  'auth.signup.submit': 'Account maken',
  'auth.signup.haveAccount': 'Heb je al een account?',
  'auth.signup.terms': 'Door een account te maken ga je akkoord met de voorwaarden en de verwerkersovereenkomst.',
  'auth.forgot': 'Wachtwoord vergeten?',
  'auth.side.title': 'Je agenda, je klanten, je salon.',
  'auth.side.body': 'Klanten boeken zelf, jij ziet het meteen. Herinneringen gaan vanzelf. Alles op je telefoon en aan de balie.',
  'auth.side.foot': 'Gegevens in de EU · geen reclame',
  'auth.card.weekday': 'woensdag',
  'auth.card.month': 'okt',
  'auth.card.service': 'Knippen en föhnen',
  'auth.card.with': 'Bij Sanne · Salon Lente',
  'auth.card.label': 'Afspraakkaartje',
  'auth.point.book': 'Klanten boeken zelf, ook ’s avonds',
  'auth.point.remind': 'Herinneringen gaan vanzelf',
  'auth.point.free': 'Geen commissie per boeking',
  'auth.day.title': 'Vandaag',
  'auth.day.1': 'Knippen',
  'auth.day.2': 'Kleuren',
  'auth.day.3': 'Baard trimmen',
  'auth.forgotTitle': 'Wachtwoord vergeten',
  'auth.forgotIntro': 'Vul je e-mailadres in. We sturen je een link om een nieuw wachtwoord te kiezen.',
  'auth.forgotSend': 'Stuur de link',
  'auth.forgotSent': 'Als er een account bij dit e-mailadres hoort, staat de link zo in je mailbox. Hij werkt 1 uur.',
  'auth.resetTitle': 'Kies een nieuw wachtwoord',
  'auth.resetInvalid': 'Deze link werkt niet meer. Vraag een nieuwe aan.',
  'auth.newPassword': 'Nieuw wachtwoord',
  'invite.title': 'Welkom bij {salon}',
  'invite.subtitle': 'Je krijgt toegang tot de agenda als {name}.',
  'invite.signUp': 'Account maken en meedoen',
  'invite.accept': 'Uitnodiging accepteren',
  'invite.otherAccount': 'Deze uitnodiging is voor {email}, maar je bent ingelogd als {current}. Log uit en log in met het juiste e-mailadres.',
  'invite.invalidTitle': 'Uitnodiging werkt niet',
  'verify.banner': 'Bevestig je e-mailadres: we stuurden een link naar {email}.',
  'verify.bannerShort': 'Bevestig je e-mailadres',
  'verify.resend': 'Opnieuw sturen',
  'verify.sent': 'Verstuurd',
  'field.name': 'Je naam',
  'field.email': 'E-mailadres',
  'field.password': 'Wachtwoord',
  'field.passwordHint': 'Minstens 10 tekens.',
  'start.title': 'Hoe heet je salon?',
  'start.subtitle': 'Dit zien je klanten op je boekingspagina. Je kunt het later aanpassen.',
  'start.salonName': 'Naam van je salon',
  'start.type': 'Wat voor zaak heb je?',
  'start.submit': 'Verder',
  'type.hair': 'Kapsalon',
  'type.barber': 'Barbershop',
  'type.nails': 'Nagelstudio',
  'type.beauty': 'Schoonheidssalon',
  'type.pedicure': 'Pedicure',
  'type.massage': 'Massage',
  'type.lashes_brows': 'Wimpers & wenkbrauwen',
  'type.other': 'Anders',
  'today.morning': 'Goedemorgen',
  'today.afternoon': 'Goedemiddag',
  'today.evening': 'Goedenavond',
  'today.empty.title': 'Nog geen afspraken vandaag',
  'today.empty.body': 'Maak een afspraak in de agenda of deel je boekingslink, dan boeken klanten zelf.',
  'today.setup.title': 'Zet je salon klaar',
  'today.setup.wizard': 'Basis klaarzetten (5 minuten)',
  'today.setup.testBooking': 'Doe een testboeking als klant',
  'today.setup.hours': 'Openingstijden controleren',
  'today.setup.services': 'Diensten en prijzen toevoegen',
  'today.setup.team': 'Nodig je team uit (als je niet alleen werkt)',
  'today.setup.booking': 'Je boekingslink delen',
  'today.setup.soon': 'binnenkort',
  'trial.daysLeft': 'Nog {n} dagen gratis',
  'clients.empty.title': 'Je klanten',
  'clients.empty.body': 'Iedereen die online boekt of die je in de agenda zet, verschijnt hier met hun afspraken.',
  'salon.title': 'Salon',
  'salon.staffNote': 'De instellingen van de salon beheert de eigenaar. Hier vind je je eigen account.',
  'salon.group.salon': 'Je salon',
  'salon.group.reach': 'Klanten bereiken',
  'salon.group.account': 'Account',
  'salon.services': 'Diensten',
  'salon.team': 'Team',
  'salon.hours': 'Openingstijden',
  'salon.booking': 'Online boeken',
  'salon.messages': 'Berichten',
  'salon.business': 'Bedrijfsgegevens',
  'salon.subscription': 'Abonnement',
  'salon.integrations': 'Koppelingen',
  'salon.privacy': 'Privacy en gegevens',
  'hub.intro': 'Alles wat je één keer instelt. Je kunt het altijd aanpassen.',
  'hub.you': 'Jij',
  'hub.services': 'Wat klanten kunnen boeken, met duur en prijs.',
  'hub.team': 'Wie er werkt, wanneer, en wat ze doen.',
  'hub.hours': 'Wanneer je open bent, feestdagen en vakanties.',
  'hub.locations': 'Je zaken, elk met eigen tijden en team.',
  'hub.booking': 'Je boekingslink, de knop op je website en de regels.',
  'hub.messages': 'Bevestigingen en herinneringen die vanzelf gaan.',
  'hub.business': 'Naam, adres en gegevens voor je klanten.',
  'hub.privacy': 'Verwerkersovereenkomst, support en je gegevens.',
  'hub.subscription': 'Je abonnement en facturen.',
  'hub.integrations': 'Andere apps aan KoalaSpot koppelen.',
  'hub.account': 'Hoe jij inlogt: wachtwoord en tweestapsverificatie.',
  'hub.servicesCount': '{n} diensten',
  'hub.teamCount': '{n} in het team',
  'hub.locationsCount': '{n} locaties',
  'hub.onlineCount': '{n} online te boeken',
  'hub.loginCount': '{n} kunnen inloggen',
  'hub.loginOne': '1 kan inloggen',
  'hub.closed': 'dicht',
  'hub.nextClosed': 'Dicht op {date}: {name}',
  'hub.bookingOn': 'Aan',
  'hub.bookingOff': 'Uit',
  'hub.bookings30': '{n} online geboekt in de laatste 30 dagen',
  'hub.reminder': 'Herinnering {h} uur van tevoren',
  'hub.reminderOff': 'Geen herinnering',
  'hub.sent30': '{n} verstuurd in 30 dagen',
  'hub.failed30': '{n} niet aangekomen',
  'hub.dpaSigned': 'Verwerkersovereenkomst akkoord sinds {date}',
  'hub.dpaMissing': 'Verwerkersovereenkomst nog niet akkoord',
  'hub.supportOn': 'Support kan meekijken tot {date}',
  'hub.link': 'Je boekingspagina',
  'hub.linkBody': 'Deel de link, zet hem in je Instagram-bio of achter de knop op je website.',
  'hub.open': 'Bekijken',
  'account.logout': 'Uitloggen',
  'account.language': 'English',
  'error.generic': 'Er ging iets mis. Probeer het opnieuw.',
  'error.page.title': 'Hier ging iets mis',
  'error.page.body': 'We hebben het gezien en kijken ernaar. Laad de pagina opnieuw; meestal werkt het dan weer.',
  'error.page.reload': 'Opnieuw laden',
};

const nl = { ...baseNl, ...setupNl, ...calendarNl, ...adminNl, ...accountNl, ...tourNl };
export type TKey = keyof typeof nl;
type Key = TKey;

const baseEn: Record<keyof typeof baseNl, string> = {
  'nav.today': 'Today',
  'nav.agenda': 'Calendar',
  'nav.clients': 'Clients',
  'nav.salon': 'Salon',
  'nav.new': 'New',
  'auth.login.title': 'Log in',
  'auth.login.submit': 'Log in',
  'auth.login.noAccount': 'No account yet?',
  'auth.login.tryFree': 'Try free for 14 days',
  'auth.signup.title': 'Try free for 14 days',
  'auth.signup.subtitle': 'No payment details needed. Your booking page is live within 5 minutes.',
  'auth.signup.submit': 'Create account',
  'auth.signup.haveAccount': 'Already have an account?',
  'auth.signup.terms': 'By creating an account you agree to the terms and the data processing agreement.',
  'auth.forgot': 'Forgot your password?',
  'auth.side.title': 'Your calendar, your clients, your salon.',
  'auth.side.body': 'Clients book themselves and you see it right away. Reminders go out on their own. All on your phone and at the counter.',
  'auth.side.foot': 'Data in the EU · no ads',
  'auth.card.weekday': 'Wednesday',
  'auth.card.month': 'Oct',
  'auth.card.service': 'Cut and blow-dry',
  'auth.card.with': 'With Sanne · Salon Lente',
  'auth.card.label': 'Appointment card',
  'auth.point.book': 'Clients book themselves, even at night',
  'auth.point.remind': 'Reminders go out on their own',
  'auth.point.free': 'No commission per booking',
  'auth.day.title': 'Today',
  'auth.day.1': 'Haircut',
  'auth.day.2': 'Colour',
  'auth.day.3': 'Beard trim',
  'auth.forgotTitle': 'Forgot your password',
  'auth.forgotIntro': "Enter your email address. We'll send you a link to choose a new password.",
  'auth.forgotSend': 'Send the link',
  'auth.forgotSent': "If there's an account for this address, the link will be in your inbox shortly. It works for 1 hour.",
  'auth.resetTitle': 'Choose a new password',
  'auth.resetInvalid': "This link doesn't work anymore. Request a new one.",
  'auth.newPassword': 'New password',
  'invite.title': 'Welcome to {salon}',
  'invite.subtitle': 'You get access to the calendar as {name}.',
  'invite.signUp': 'Create account and join',
  'invite.accept': 'Accept invitation',
  'invite.otherAccount': "This invitation is for {email}, but you're logged in as {current}. Log out and log in with the right address.",
  'invite.invalidTitle': "Invitation doesn't work",
  'verify.banner': 'Confirm your email address: we sent a link to {email}.',
  'verify.bannerShort': 'Confirm your email address',
  'verify.resend': 'Send again',
  'verify.sent': 'Sent',
  'field.name': 'Your name',
  'field.email': 'Email address',
  'field.password': 'Password',
  'field.passwordHint': 'At least 10 characters.',
  'start.title': 'What is your salon called?',
  'start.subtitle': 'Clients see this on your booking page. You can change it later.',
  'start.salonName': 'Salon name',
  'start.type': 'What kind of business is it?',
  'start.submit': 'Continue',
  'type.hair': 'Hair salon',
  'type.barber': 'Barbershop',
  'type.nails': 'Nail studio',
  'type.beauty': 'Beauty salon',
  'type.pedicure': 'Pedicure',
  'type.massage': 'Massage',
  'type.lashes_brows': 'Lashes & brows',
  'type.other': 'Other',
  'today.morning': 'Good morning',
  'today.afternoon': 'Good afternoon',
  'today.evening': 'Good evening',
  'today.empty.title': 'No appointments today yet',
  'today.empty.body': 'Add an appointment in the calendar or share your booking link so clients can book themselves.',
  'today.setup.title': 'Set up your salon',
  'today.setup.wizard': 'Set up the basics (5 minutes)',
  'today.setup.testBooking': 'Make a test booking as a client',
  'today.setup.hours': 'Check opening hours',
  'today.setup.services': 'Add services and prices',
  'today.setup.team': "Invite your team (if you don't work alone)",
  'today.setup.booking': 'Share your booking link',
  'today.setup.soon': 'coming soon',
  'trial.daysLeft': '{n} days of free trial left',
  'clients.empty.title': 'Your clients',
  'clients.empty.body': 'Everyone who books online or whom you add in the calendar appears here with their appointments.',
  'salon.title': 'Salon',
  'salon.staffNote': 'The owner manages the salon settings. Your own account is here.',
  'salon.group.salon': 'Your salon',
  'salon.group.reach': 'Reaching clients',
  'salon.group.account': 'Account',
  'salon.services': 'Services',
  'salon.team': 'Team',
  'salon.hours': 'Opening hours',
  'salon.booking': 'Online booking',
  'salon.messages': 'Messages',
  'salon.business': 'Business details',
  'salon.subscription': 'Subscription',
  'salon.integrations': 'Connections',
  'salon.privacy': 'Privacy and data',
  'hub.intro': 'Everything you set up once. You can always change it.',
  'hub.you': 'You',
  'hub.services': 'What clients can book, with duration and price.',
  'hub.team': 'Who works, when, and what they do.',
  'hub.hours': 'When you’re open, public holidays and closures.',
  'hub.locations': 'Your salons, each with its own hours and team.',
  'hub.booking': 'Your booking link, the website button and the rules.',
  'hub.messages': 'Confirmations and reminders that go out by themselves.',
  'hub.business': 'Name, address and details for your clients.',
  'hub.privacy': 'Processing agreement, support and your data.',
  'hub.subscription': 'Your subscription and invoices.',
  'hub.integrations': 'Connect other apps to KoalaSpot.',
  'hub.account': 'How you log in: password and two-step verification.',
  'hub.servicesCount': '{n} services',
  'hub.teamCount': '{n} on the team',
  'hub.locationsCount': '{n} locations',
  'hub.onlineCount': '{n} bookable online',
  'hub.loginCount': '{n} can log in',
  'hub.loginOne': '1 can log in',
  'hub.closed': 'closed',
  'hub.nextClosed': 'Closed on {date}: {name}',
  'hub.bookingOn': 'On',
  'hub.bookingOff': 'Off',
  'hub.bookings30': '{n} booked online in the last 30 days',
  'hub.reminder': 'Reminder {h} hours before',
  'hub.reminderOff': 'No reminder',
  'hub.sent30': '{n} sent in 30 days',
  'hub.failed30': '{n} not delivered',
  'hub.dpaSigned': 'Processing agreement accepted on {date}',
  'hub.dpaMissing': 'Processing agreement not accepted yet',
  'hub.supportOn': 'Support can look in until {date}',
  'hub.link': 'Your booking page',
  'hub.linkBody': 'Share the link, put it in your Instagram bio or behind the button on your website.',
  'hub.open': 'View',
  'account.logout': 'Log out',
  'account.language': 'Nederlands',
  'error.generic': 'Something went wrong. Please try again.',
  'error.page.title': 'Something went wrong here',
  'error.page.body': 'We’ve been notified and will look into it. Reload the page; it usually works again.',
  'error.page.reload': 'Reload',
};

const en: Record<Key, string> = { ...baseEn, ...setupEn, ...calendarEn, ...adminEn, ...accountEn, ...tourEn };

export type Locale = 'nl' | 'en';
const dictionaries: Record<Locale, Record<Key, string>> = { nl, en };

function initialLocale(): Locale {
  try {
    const saved = localStorage.getItem('locale');
    if (saved === 'nl' || saved === 'en') return saved;
  } catch {
    // storage unavailable: fall through
  }
  return navigator.language.toLowerCase().startsWith('nl') ? 'nl' : 'en';
}

let locale: Locale = initialLocale();
const listeners = new Set<() => void>();

export function setLocale(next: Locale) {
  locale = next;
  try {
    localStorage.setItem('locale', next);
  } catch {
    // ignore
  }
  document.documentElement.lang = next;
  listeners.forEach((l) => l());
}

export function useLocale(): Locale {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => locale,
  );
}

export function useT() {
  const current = useLocale();
  return (key: Key, vars: Record<string, string | number> = {}) =>
    dictionaries[current][key].replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? ''));
}

export function formatToday(l: Locale, date = new Date()) {
  return new Intl.DateTimeFormat(l === 'nl' ? 'nl-NL' : 'en-GB', { weekday: 'long', day: 'numeric', month: 'long' }).format(date);
}
